import React, { useState, useEffect, useCallback } from 'react';

/**
 * public/popup.png 이미지를 중앙에 띄우는 팝업 컴포넌트
 * @param {boolean} isOpen - 팝업 열림/닫힘 상태
 * @param {Function} onClose - 팝업을 닫는 함수
 */
const ImagePopup = ({ isOpen, onClose }) => {

    // isOpen이 false면 아무것도 렌더링하지 않음
    if (!isOpen) return null;

    return (
        // 팝업 오버레이 (배경을 어둡게 하고 팝업을 중앙에 고정)
        <div style={styles.overlay}>


            
            {/* 팝업 컨테이너 (이미지 및 버튼 포함) */}
            <div style={styles.popupContainer}>
                {/* 팝업 이미지 */}
                <img 
                    src={`${process.env.PUBLIC_URL}/popup.png`} // public 폴더 경로
                    alt="콘텐츠 참여 유도 팝업" 
                    style={styles.popupImage} 
                />

                {/* 하단 버튼 그룹 */}
                <div style={styles.buttonGroup}>
                    {/* 앱 설치하기 버튼 */}
                    <button 
                        onClick={() => {
                            //console.log("앱 설치하기 클릭");
                            // 여기에 앱 설치 관련 로직 추가 (예: 스토어 링크로 이동)


                            const userAgent = navigator.userAgent || navigator.vendor || window.opera;

                            if (/android/i.test(userAgent)) {
                            // 안드로이드일 경우
                            window.location.href = 'https://play.google.com/store/apps/details?id=kr.modii&hl=ko-KR';
                            } else if (/iPad|iPhone|iPod/i.test(userAgent) && !window.MSStream) {
                            // iOS일 경우
                            window.location.href = 'https://apps.apple.com/kr/app/%EB%AA%A8%EB%94%94-modii/id1594496794';
                            } else {
                            // 다른 플랫폼이나 웹 브라우저일 경우
                            alert('모디는 안드로이드 또는 iOS에서만 지원됩니다.');
                            }
      
                            onClose(); // 팝업 닫기
                        }}
                        style={styles.installButton}
                    >
                        앱 설치하기
                    </button>
                    
                    {/* 다음에 버튼 */}
                    <button 
                        onClick={() => {
                            console.log("다음에 클릭");
                            onClose(); // 팝업 닫기
                        }}
                        style={styles.laterButton}
                    >
                        다음에
                    </button>
                </div>
            </div>
        </div>
    );
};

// ----------------------------------------------------
// 스타일 정의
// ----------------------------------------------------
const styles = {
    overlay: {
        position: 'fixed', // 화면에 고정
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.6)', // 어두운 배경
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000, // 다른 요소 위에 표시
    },
    popupContainer: {
        backgroundColor: '#fff', // 팝업 배경색 (이미지 아래 버튼이 보이므로 필요)
        borderRadius: '10px',
        overflow: 'hidden', // 이미지와 버튼이 컨테이너 밖으로 나가지 않도록
        maxWidth: '350px', // 팝업의 최대 너비
        width: '90%', // 모바일 화면에서 반응형으로 조절
        boxShadow: '0 5px 15px rgba(0, 0, 0, 0.3)',
    },
    popupImage: {
        width: '100%', // 컨테이너 너비에 맞춤
        height: 'auto', // 비율 유지
        display: 'block', // 하단 여백 제거
    },
    buttonGroup: {
        display: 'flex',
        // 사진에서는 버튼들이 컨테이너의 전체 너비를 나누어 가지고 있습니다.
        // flex-grow를 사용하거나, 각 버튼의 너비를 50%로 설정할 수 있습니다.
        width: '100%',
    },
    installButton: {
        flexGrow: 1, // 남은 공간을 채움
        padding: '15px 0',
        backgroundColor: '#ff4d4f', // 붉은색 (사진 참고)
        color: '#fff',
        border: 'none',
        fontSize: '16px',
        cursor: 'pointer',
        fontWeight: 'bold',
        borderRadius: '0 0 0 10px', // 왼쪽 하단만 둥글게 (팝업 컨테이너와 일치)
        // 팝업 컨테이너 전체의 border-radius와 일치시키기 위해 조정이 필요할 수 있습니다.
    },
    laterButton: {
        flexGrow: 1, // 남은 공간을 채움
        padding: '15px 0',
        backgroundColor: '#f0f0f0', // 회색 (사진 참고)
        color: '#333',
        border: 'none',
        fontSize: '16px',
        cursor: 'pointer',
        fontWeight: 'bold',
        borderRadius: '0 0 10px 0', // 오른쪽 하단만 둥글게
    },
};

export default ImagePopup;